import { cn } from 'cn';
import { type ReactNode, useId } from 'react';

import { isFieldRequired, unique } from '@vestigas/utils';

import { ValidationError } from '@vestigas/ui/molecules';

import { MultiSelectSuppliers, type Option } from '../SelectServerDriven';

import { useFieldContext } from './form-context';
import { InputLabel } from './InputLabel';

// Define a Company type based on the expected structure; TODO: this should come as response type from the request.
type Company = {
  id: string;
  name: string;
};

type P = {
  readonly classNameErrors?: string;
  readonly formatOptionLabel?: (option: Option<Company>) => ReactNode;
  readonly hint?: string;
  readonly isClearable?: boolean;
  readonly isDisabled?: boolean;
  readonly isMultiSelect?: boolean;
  readonly isRemovableValue?: (data: Option<Company>) => boolean;
  readonly label?: string;
  readonly placeholder?: string;
  readonly testId?: string;
} & ComponentStyling;

export const MultiSelectSuppliersField = ({
  className,
  classNameErrors,
  formatOptionLabel,
  hint,
  isClearable = true,
  isDisabled = false,
  isMultiSelect = true,
  isRemovableValue,
  label,
  placeholder,
  style,
  testId,
}: P) => {
  const field = useFieldContext();

  const isRequired = isFieldRequired(
    field.options.form.options.validators,
    field.name,
  );

  const hasErrors = Boolean(field.state.meta.errors?.length);

  const id = useId();

  return (
    <div className={cn('relative', className)} style={style}>
      {Boolean(label) && (
        <InputLabel hint={hint} htmlFor={id} isRequired={isRequired}>
          {label}
        </InputLabel>
      )}
      <MultiSelectSuppliers
        formatOptionLabel={formatOptionLabel}
        isClearable={isClearable}
        isDisabled={isDisabled}
        isMultiSelect={isMultiSelect}
        isRemovableValue={isRemovableValue}
        placeholder={placeholder}
        // testId={testId}
        value={field.state.value ?? []}
        onChange={(companies) => {
          const isArray = Array.isArray(companies);
          if (isArray) {
            field.handleChange(companies.map(({ id }) => id));
          } else {
            field.handleChange(companies?.id ?? '');
          }
        }}
      />
      {hasErrors ? (
        <ValidationError className={classNameErrors}>
          {unique(field.state.meta.errors.map(({ message }) => message)).join(
            ', ',
          )}
        </ValidationError>
      ) : null}
    </div>
  );
};
